// import the original component so that base styles are applied first
import 'SourceComponent/Breadcrumbs/Breadcrumbs.component';
// import our modified styles to override some of the default ones
import './Breadcrumbs.override.style.scss';

// re-export all the original exports from the parent theme untouched
export * from 'SourceComponent/Breadcrumbs/Breadcrumbs.component';
export { default } from 'SourceComponent/Breadcrumbs/Breadcrumbs.component';